module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture12-ac50f7a739e2b0283a84df2b2cd367e7.jpg";